import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { PATH } from 'src/features/navigation/utils/constants';
import { Button } from 'src/registry/ui/Button';
import { ICON_MAP } from 'src/utils/constants';
import { commonMessages } from 'src/utils/messages';

type BackButtonProps = {
    customRoute?: string;
};

const BackButton = ({ customRoute }: BackButtonProps) => {
    const { formatMessage } = useIntl();
    const navigate = useNavigate();

    return (
        <Button
            className="-mt-6 cursor-pointer place-self-start p-0"
            variant="link"
            onClick={() => {
                if (window.history.length > 1) {
                    navigate(-1);
                    return;
                }
                if (customRoute) {
                    navigate(customRoute);
                    return;
                }
                navigate(`/${PATH.HOME}`, { replace: true });
            }}
        >
            <>
                <FontAwesomeIcon icon={ICON_MAP.CHEVRON_LEFT} className="opacity-50" />
                {formatMessage(commonMessages.back)}
            </>
        </Button>
    );
};

export default BackButton;
